export const nav = {
    p1: `Tutaj można zarządzać danymi osobowymi, zmienić hasło, integracje i subskrypcję oraz dostosować preferencje użytkownika`,
    p2: `Moje konto`,
    p3: `Konfiguracja danych obiektu, personalizacja wiadomości powitalnych i regulaminów, połączenie z lokalnymi organami w celu automatycznego przesyłania zgłoszeń podróżnych oraz dostosowanie preferencji operacyjnych`,
    p4: `Ustawienia obiektu`,
    p5: `Zarządzanie usługami dodatkowymi obiektu i ich promocja: wynajem przestrzeni, wycieczki i inne dodatki, które wzbogacają doświadczenia gości i zwiększają przychody`,
    p6: `Sprzedaż krzyżowa`,
    p7: `Utwórz nowy obiekt`,
    p8: `Wiadomość potwierdzająca została wysłana`,
    p9: `Obiekty`,
    p10: ``,
    p11: ``,
    p12: ``,
    p13: ``,
    p14: ``,
    p15: ``,
    p16: ``,
    p17: ``,
    p18: ``,
    p19: ``,
    p20: ``,
    p21: ``,
    p22: ``,
    p23: ``,
};
